<template>
  <div>
    <a-modal
      :visible="paymentProcess.show"
      :title="$t('PAYMENT_PROCCESS_RECIVED_TITLE')"
      :footer="null"
      :closable="false"
      :mask-closable="false"
      @cancel="handleCloseProcess"
    >
      <a-steps>
        <a-step
          status="finish"
          :title="paymentTotal"
        >
          <a-icon
            slot="icon"
            type="solution"
          />
        </a-step>
        <a-step
          status="process"
          :title="$t('PAYMENT_PROCCESS_RECIVED_STEP')"
        >
          <a-icon
            slot="icon"
            type="loading"
          />
        </a-step>
      </a-steps>
      <div
        style="margin-top: 20px"
        class="text-center"
      >
        <a-statistic-countdown
          :title="$t('PAYMENT_PROCCESS_RECIVED_COUNTDOWN')"
          :value="paymentProcess.countdown"
          format="mm:ss"
        />
      </div>
      <div
        style="margin-top: 40px"
        v-html="paymentFinish"
      />
      <div style="margin-top: 20px">
        <div v-html="paymentContact" />
        <p>
          <i>{{ $t('PAYMENT_ERROR_NOTE') }}</i>
        </p>
      </div>
    </a-modal>

    <a-modal
      :visible="confirmBox"
      :title="$t('PAYMENT_PROCCESS_TRANSFER_FINSH_TITLE')"
      @ok="handleConfirmOk"
      @cancel="handleConfirmCancel"
    >
      {{ $t('PAYMENT_PROCCESS_TRANSFER_CONFIRM') }}
      <ul>
        <li>
          <span>{{ $t('PAYMENT_DATA_TO_ID') }}</span>
          <b style="margin-left: 5px">{{ paymentMethodName }}</b>
        </li>
        <li>
          <span>{{ $t('PAYMENT_DATA_METHOD') }}</span>
          <b style="margin-left: 5px">{{ payment.method && payment.method.code }}</b>
        </li>
        <li>
          <span>{{ $t('PAYMENT_DATA_MONEY') }}</span>
          <b style="margin-left: 5px">{{ paymentTotal }}</b>
        </li>
        <li>
          <span>{{ $t('PAYMENT_DATA_NOTE') }}</span>
          <b style="margin-left: 5px">{{ paymentNote }}</b>
        </li>
      </ul>
    </a-modal>
  </div>
</template>

<script>
export default {
  name: 'PaymentModals',
  props: {
    paymentProcess: {
      type: Object,
      required: true,
    },
    confirmBox: {
      type: Boolean,
      default: false,
    },
    paymentTotal: {
      type: String,
      required: true,
    },
    paymentMethodName: {
      type: String,
      required: true,
    },
    payment: {
      type: Object,
      required: true,
    },
    paymentNote: {
      type: String,
      required: true,
    },
    paymentFinish: {
      type: String,
      required: true,
    },
    paymentContact: {
      type: String,
      required: true,
    },
  },
  methods: {
    handleCloseProcess() {
      this.$emit('close-process');
    },
    handleConfirmOk() {
      this.$emit('confirm-ok');
    },
    handleConfirmCancel() {
      this.$emit('confirm-cancel');
    },
  },
};
</script>

<style scoped>
.text-center {
  text-align: center;
}
</style>
